import { OPERATOR_EQUALS, OPERATOR_IN } from '@atlaskit/jql-ast';

export const PACKAGE_NAME = 'jiraFilterRefinement';
export const TEAM_NAME = 'empanada';
export const SOURCE_NAME = 'filterRefinement';

// Field JQL terms
export const ASSIGNEE = 'assignee';
export const ISSUE_KEY = 'issuekey';
export const TEXT_FIELDS = 'textfields';
export const PROJECT_FIELD = 'project';
export const REPORTER = 'reporter';

export const VALID_ASSIGNEE_OPERATORS = new Set([OPERATOR_EQUALS, OPERATOR_IN]);

export const BASIC = 'BASIC' as const;
export const ADVANCED = 'ADVANCED' as const;
export const JQL = 'JQL' as const;

export type Tabs = 'BASIC' | 'ADVANCED' | 'JQL';
